import { ListableInfo } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { type SimpleUser } from '@models/SimpleUser';
import { formatDateTime } from '@utils/dateFormatUtils';
import { fullName } from '@utils/stringFormatUtils';

export interface Comment {
    content: string;
    createTime: string;
    user: SimpleUser;
}

interface FormatCommentProps {
    comment: Comment;
}

export default function FormatComment({
    comment,
}: FormatCommentProps): ReactNode {
    const { content } = comment;
    const user = fullName(comment.user);
    const date = formatDateTime(comment.createTime);

    const label: ReactNode = (
        <div>
            {user}
            <br />
            {date}
        </div>
    );

    return <ListableInfo label={label} value={content} />;
}
